import * as React from "react";
const SvgFiRrCustomization = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-customization_svg__a)">
      <path
        fill="#062147"
        d="M24 4v2a1 1 0 1 1-2 0V4c0-1.103-.897-2-2-2h-2a1 1 0 1 1 0-2h2c2.206 0 4 1.794 4 4m-1 8a1 1 0 0 0-1 1v2c0 1.103-.897 2-2 2h-2a1 1 0 1 0 0 2h2c2.206 0 4-1.794 4-4v-2a1 1 0 0 0-1-1M6 7a1 1 0 0 0 1-1V4c0-1.103.897-2 2-2h2a1 1 0 1 0 0-2H9C6.794 0 5 1.794 5 4v2a1 1 0 0 0 1 1m12.914 5.792a.92.92 0 0 0-.183-1.036L16.785 9.81l1.244-2.622a.918.918 0 0 0-1.216-1.216l-2.622 1.244-1.946-1.946a.918.918 0 0 0-1.563.723l.287 2.797-2.567 1.346a.918.918 0 0 0 .245 1.713l1.742.345L.293 22.293a.999.999 0 1 0 1.414 1.414l10.12-10.119.377 1.792a.917.917 0 0 0 1.718.222l1.298-2.568 2.784.284a.92.92 0 0 0 .91-.526"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-customization_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCustomization;
